import { css } from '@emotion/react'
import { memo } from 'react'
import i18n from '../../utilities/i18n'
import { getThemeSpacing } from '../styles/appTheme'
import APP_BREAKPOINTS, {
    maxPinWidth,
    maxRoomWidth,
} from '../styles/breakpoints'
import Button from './Button'

export const buttonTipStyles = css({
    fontWeight: 800,
    fontSize: '0.80rem',
    minWidth: 56,
    textWrap: 'nowrap',
    padding: `${getThemeSpacing(0.3)} ${getThemeSpacing(1)}`,
    [maxRoomWidth(APP_BREAKPOINTS.sm)]: {
        padding: `${getThemeSpacing(0.2)} ${getThemeSpacing(0.75)}`,
    },
    [maxPinWidth(APP_BREAKPOINTS.sm)]: {
        padding: `${getThemeSpacing(0.2)} ${getThemeSpacing(0.75)}`,
    },
})

interface TipButtonProps {
    onClick: () => void
}

const TipButton = memo<TipButtonProps>(({ onClick }) => {
    return (
        <Button
            onClick={onClick}
            data-testid="Button__Tip"
            size="small"
            css={buttonTipStyles}
        >
            {i18n.t('chat.tip')}
        </Button>
    )
})

export default TipButton
